import React from 'react';
import { Box, Typography } from '@mui/material';

const getNonePreset = (isLightTheme) => ({
  background: 'transparent',
  color: isLightTheme ? 'rgba(15,20,32,1)' : '#fff',
  border: isLightTheme ? '1px solid rgba(15,20,32,0.1)' : '1px solid rgba(255,255,255,0.08)',
});

const TEXT_BACKGROUND_STYLES = {
  ocean: {
    background: 'linear-gradient(135deg, rgba(0,212,255,0.26) 0%, rgba(0,69,255,0.38) 100%)',
    color: '#effcff',
    border: '1px solid rgba(0,212,255,0.24)',
  },
  sunset: {
    background: 'linear-gradient(135deg, rgba(255,128,0,0.32) 0%, rgba(255,69,96,0.34) 100%)',
    color: '#fff6ef',
    border: '1px solid rgba(255,140,80,0.24)',
  },
  violet: {
    background: 'linear-gradient(135deg, rgba(126,87,255,0.32) 0%, rgba(64,196,255,0.24) 100%)',
    color: '#f7f3ff',
    border: '1px solid rgba(126,87,255,0.24)',
  },
  midnight: {
    background: 'linear-gradient(135deg, rgba(18,23,35,0.96) 0%, rgba(41,54,76,0.96) 100%)',
    color: '#ffffff',
    border: '1px solid rgba(255,255,255,0.08)',
  },
  lime: {
    background: 'linear-gradient(135deg, rgba(103,220,106,0.32) 0%, rgba(0,212,255,0.22) 100%)',
    color: '#f4fff4',
    border: '1px solid rgba(103,220,106,0.24)',
  },
};

const PostTextBlock = ({ text, textBackground = 'none', compact = false, sx = {}, isLightTheme = false }) => {
  if (!text) return null;

  const preset = TEXT_BACKGROUND_STYLES[textBackground] || getNonePreset(isLightTheme);

  return (
    <Box
      sx={{
        mt: 1.25,
        p: compact ? 1.25 : 1.75,
        borderRadius: compact ? '14px' : '18px',
        background: preset.background,
        color: preset.color,
        border: preset.border,
        boxShadow: textBackground !== 'none' ? '0 16px 36px rgba(0,0,0,0.24)' : 'none',
        ...sx,
      }}
    >
      <Typography
        variant={compact ? 'caption' : 'body2'}
        sx={{
          fontWeight: 600,
          lineHeight: 1.55,
          whiteSpace: 'pre-wrap',
          wordBreak: 'break-word',
          display: compact ? '-webkit-box' : 'block',
          WebkitLineClamp: compact ? 3 : 'unset',
          WebkitBoxOrient: compact ? 'vertical' : 'unset',
          overflow: compact ? 'hidden' : 'visible',
          color: 'inherit',
          textAlign: compact ? 'center' : 'left',
        }}
      >
        {text}
      </Typography>
    </Box>
  );
};

export default PostTextBlock;